
document.addEventListener('DOMContentLoaded',()=>{
  // --- Mobile Menu ---
  const mBtn = document.getElementById('MobileMenuBtn');
  const mMenu = document.getElementById('MobileMenu');
  const mClose = document.getElementById('MobileMenuClose');
  const mOverlay = document.getElementById('MobileMenuOverlay');
  function openMobile(){ if(mMenu){ mMenu.classList.add('open'); document.body.style.overflow='hidden'; } }
  function closeMobile(){ if(mMenu){ mMenu.classList.remove('open'); document.body.style.overflow=''; } }
  mBtn?.addEventListener('click', openMobile);
  mClose?.addEventListener('click', closeMobile);
  mOverlay?.addEventListener('click', closeMobile);

  // --- Sticky header reveal ---
  window.addEventListener('scroll',()=>{
    document.querySelectorAll('.reveal').forEach(el=>{ if(el.getBoundingClientRect().top < window.innerHeight*0.9) el.classList.add('in'); });
    const sticky=document.querySelector('.sticky-atc'); if(sticky) sticky.classList.toggle('visible', window.scrollY>500);
    const btt=document.querySelector('.back-to-top'); if(btt) btt.classList.toggle('visible', window.scrollY>600);
  });

  // --- Cart & Search ---
  window.openCart=()=>document.querySelector('.cart-drawer')?.classList.add('open');
  window.closeCart=()=>document.querySelector('.cart-drawer')?.classList.remove('open');
  document.querySelectorAll('[data-cart-open]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault(); openCart()}));
  document.querySelectorAll('[data-cart-close]').forEach(b=>b.addEventListener('click', closeCart));
  window.openSearch=()=>document.querySelector('.search-drawer')?.classList.add('open');
  window.closeSearch=()=>document.querySelector('.search-drawer')?.classList.remove('open');
  document.querySelectorAll('[data-search-open]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault(); openSearch()}));

  // --- Gallery Fix - no more izbita ---
  const galleryMain = document.getElementById('GalleryMain') || document.querySelector('.gallery-main');
  const mainImg = document.getElementById('MainImage') || document.querySelector('.gallery-main img');
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const counter = document.getElementById('GalleryCurrent');
  let currentIndex = 0;
  function updateGallery(index){
    currentIndex = index;
    thumbs.forEach(t=>t.classList.remove('active'));
    if(thumbs[index]){ 
      thumbs[index].classList.add('active'); 
      if(mainImg) mainImg.src = thumbs[index].dataset.src;
    }
    if(counter) counter.textContent = index+1;
    // Remove zoom when changing image
    galleryMain?.classList.remove('zoomed');
  }
  thumbs.forEach((thumb,i)=>{
    thumb.addEventListener('click', ()=>{
      if(galleryMain?.classList.contains('zoomed')){ galleryMain.classList.remove('zoomed'); return; }
      updateGallery(i);
    });
  });
  galleryMain?.addEventListener('click', ()=>{
    galleryMain.classList.toggle('zoomed');
  });
  // Swipe for mobile
  let startX = 0;
  galleryMain?.addEventListener('touchstart', e=>{ startX = e.touches[0].clientX; }, {passive:true});
  galleryMain?.addEventListener('touchend', e=>{
    if(galleryMain?.classList.contains('zoomed')) return;
    const diff = e.changedTouches[0].clientX - startX;
    if(Math.abs(diff) > 50){
      if(diff < 0 && currentIndex < thumbs.length-1) updateGallery(currentIndex+1);
      if(diff > 0 && currentIndex > 0) updateGallery(currentIndex-1);
    }
  }, {passive:true});
  mainImg?.addEventListener('dragstart', e=>e.preventDefault());

  // Accordion
  document.querySelectorAll('.accordion__btn').forEach(b=>{
    b.addEventListener('click',()=>{ b.closest('.accordion__item').classList.toggle('open'); });
  });

  // Qty
  document.querySelectorAll('.qty').forEach(w=>{
    const input=w.querySelector('input');
    w.querySelectorAll('[data-qty]').forEach(btn=>{
      btn.addEventListener('click',()=>{
        let v=parseInt(input.value)||1;
        if(btn.dataset.qty==='plus') v++; else v=Math.max(1,v-1);
        input.value=v;
      });
    });
  });

  // Quick View
  window.openQuickView=(h)=>{
    const qv=document.querySelector('.quick-view');
    if(!qv) return;
    fetch(`/products/${h}?view=quick`).then(r=>r.text()).then(html=>{
      const content = qv.querySelector('.quick-view__content');
      if(content) content.innerHTML=html;
      qv.classList.add('open');
    }).catch(()=>location.href=`/products/${h}`);
  };
  window.closeQuickView=()=>document.querySelector('.quick-view')?.classList.remove('open');

  // Back to top
  document.querySelector('.back-to-top')?.addEventListener('click',()=>window.scrollTo({top:0,behavior:'smooth'}));
});
